<template>
  <div style="width: 100% ;box-sizing: border-box;overflow: hidden;background-color: white" ref="box">
    <div class="header">

      <div class="left" @click="$router.push('/zpindex')" style="cursor: pointer">
        <div class="logo1"></div>
        <div class="line"></div>
        <div class="text">招贤纳士</div>
      </div>

      <ul class="right">
        <li>
          <!--          <a href="http://ahwater.net/about" target="_blank">招聘首页</a>-->
          <router-link to="/zpindex">招聘首页</router-link>
        </li>
        <li class="border">
          <router-link to="/shzp" ref="zp" :class="flag?'router-link-active':''">招聘信息</router-link>
        </li>
        <li>
          <a href="http://ahwater.net/" target="_blank">官网首页</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "whHeader",
  components: {},
  data() {
    return {
      flag: false
    };
  },

  watch: {
    // $route() {
    //
    //
    // }
    // ,
    $route: {
      // 监听变化处理函数，默认名为handler不可以改变
      handler(nv, ov) {
        if (this.$route.path == '/sqzw') {
          this.flag = true
        }
      },
      // 开启深度监听
      // deep: true,
      // 默认执行一次
      immediate: true
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {}
};
</script>

<style scoped>
.header {
  width: 1200px;
  height: 80px;
  margin: 0 auto;
  background-color: transparent;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding-right: 10px;
  font-family: normal;
  /*background-color: white;*/

}


.left {
  height: 35px;
  width: auto;
  /*background-color: gray;*/
  display: flex;
  align-items: flex-end;
  color: #666666;
}

.logo1 {

  width: 228px;
  height: 35px;
  background-image: url("/src/assets/img/logoC@2x.png");
  background-size: 100% 100%;
  background-color: white;

}

.logo2 {
  width: 228px;
  height: 35px;
  background-image: url("/src/assets/img/沃特水务LOGO-白色.png");
  background-size: 100% 100%;
  /*background: transparent;*/
}

.line {
  width: 1px;
  height: 22px;
  /*border: 1px solid #666666;*/
  margin-left: 11.5px;
  margin-right: 12.5px;
  background-color: #666666;
}

.text {
  height: 23px;
  font-size: 18px;

}

.right {
  height: 18px;
  font-size: 18px;
  color: #303030;
  position: relative;
}

.right li {
  float: right;
  margin-left: 79px;
  font-weight: Normal;
  position: relative;
  color: #303030 !important;
}

a:-webkit-any-link {
  color: #303030;
  user-select: none;
}

.router-link-active:after {
  content: '';
  position: absolute;
  bottom: -22px;
  right: auto;
  left: calc(50% - 15.5px);
  height: 4px;
  width: 31px;
  background-color: #3772D3;

}

li {

}

.router-link-exact-active {
  /*color: #303030;*/
}

.router-link-active {
  color: #3772D3 !important;
}

</style>
